import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vueHeadful from "vue-headful";
import VueCookies from "vue-cookies";

import "./styles/index.scss";

Vue.config.productionTip = false;

Vue.component("vue-headful", vueHeadful);

Vue.use(VueCookies);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
